import type { AppRole } from '@/lib/scope';

export interface HelpTask {
  id: string;
  title: string;
  description: string;
  href: string;
  external?: boolean;
}

export interface HelpDoc {
  id: string;
  title: string;
  href: string;
}

const DOCS_BASE = 'https://workforce-docs.pages.dev/sop';

export const HELP_DOCS: HelpDoc[] = [
  { id: 'login', title: 'Đăng nhập lần đầu', href: `${DOCS_BASE}/dang-nhap` },
  { id: 'forecast', title: 'Xem dự báo 14 ngày', href: `${DOCS_BASE}/xem-du-bao` },
  { id: 'submit', title: 'Gửi điều chỉnh forecast (KAM)', href: `${DOCS_BASE}/gui-dieu-chinh` },
  { id: 'approve', title: 'Phê duyệt điều chỉnh', href: `${DOCS_BASE}/phe-duyet` },
  { id: 'warehouse', title: 'Báo cáo workload kho', href: `${DOCS_BASE}/bao-cao-kho` },
  { id: 'params', title: 'Cấu hình tham số', href: `${DOCS_BASE}/cau-hinh-tham-so` },
  { id: 'history', title: 'Nhập dữ liệu lịch sử', href: `${DOCS_BASE}/nhap-du-lieu-lich-su` },
  { id: 'audit', title: 'Truy vết & Audit', href: `${DOCS_BASE}/audit` },
];

const COMMON_TASKS: HelpTask[] = [
  {
    id: 'home',
    title: 'Trang chủ',
    description: 'Tổng quan kho hiện hành, KPI hôm nay, hoạt động gần đây.',
    href: '/',
  },
  {
    id: 'forecast',
    title: 'Xem dự báo 14 ngày',
    description: 'Biểu đồ workload theo ngày, cảnh báo độ tin cậy thấp.',
    href: '/planner/forecast',
  },
  {
    id: 'warehouse-report',
    title: 'Báo cáo workload kho',
    description: 'Số ca, số người cần có mặt cho từng ngày trong kho.',
    href: '/planner/forecast/warehouse',
  },
];

const PLANNER_TASKS: HelpTask[] = [
  {
    id: 'customer',
    title: 'Dự báo theo khách hàng',
    description: 'So sánh đóng góp đơn của từng khách hàng.',
    href: '/planner/forecast/customer',
  },
  {
    id: 'review',
    title: 'Phê duyệt điều chỉnh',
    description: 'Chấp nhận/từ chối yêu cầu từ KAM, ghi rõ lý do.',
    href: '/planner/forecast/review',
  },
];

const ADMIN_TASKS: HelpTask[] = [
  {
    id: 'config',
    title: 'Cấu hình tham số vận hành',
    description: 'Định mức (đơn/giờ/người), hệ số mùa, hệ số sự kiện.',
    href: '/admin/config',
  },
  {
    id: 'norms',
    title: 'Định mức theo khách hàng',
    description: 'Tinh chỉnh năng suất riêng cho từng khách lớn.',
    href: '/admin/config/dinhmuc',
  },
  {
    id: 'history',
    title: 'Import dữ liệu lịch sử',
    description: 'Nạp ≥ 90 ngày đơn lịch sử cho engine forecast.',
    href: '/admin/history-import',
  },
  {
    id: 'warehouses',
    title: 'Quản lý kho',
    description: 'Thông tin kho, capacity, trạng thái hoạt động.',
    href: '/admin/warehouses',
  },
];

export function getHelpTasksFor(role: AppRole): HelpTask[] {
  switch (role) {
    case 'OPS':
      return [...COMMON_TASKS];
    case 'ADMIN':
      return [...COMMON_TASKS, ...PLANNER_TASKS, ...ADMIN_TASKS];
    case 'PLANNER':
      return [...COMMON_TASKS, ...PLANNER_TASKS];
    case 'AUDITOR':
    default:
      return [...COMMON_TASKS];
  }
}
